/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Add.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromData from 'Data/ViewsData.js'
import AddAction from './AddAction/view.js'
import AddDependent from './AddDependent/logic.js'
import CancelAction from './CancelAction/view.js'
import City from './City/view.js'
import Company from './Company/logic.js'
import DateOfBirth from './DateOfBirth/view.js'
import Dependents from './Dependents/logic.js'
import EffectiveDate from './EffectiveDate/logic.js'
import Email from './Email/logic.js'
import ExistingUsers from './ExistingUsers/logic.js'
import ExpiryDate from './ExpiryDate/view.js'
import FirstName from './FirstName/logic.js'
import Gender from './Gender/logic.js'
import Info from 'DesignSystem/Info/view.js'
import LastName from './LastName/logic.js'
import MaritalStatus from './MaritalStatus/logic.js'
import ModalContent from 'DesignSystem/ModalContent/view.js'
import ModalHeader from 'DesignSystem/ModalHeader/view.js'
import PhoneNumber from './PhoneNumber/view.js'
import PlanStartDate from './PlanStartDate/view.js'
import Plans from './Plans/view.js'
import Pricing from './Pricing/logic.js'
import Professionals from './Professionals/logic.js'
import ProviderLocations from './ProviderLocations/logic.js'
import React from 'react'
import SocialSecurityNumber from './SocialSecurityNumber/view.js'
import State from './State/logic.js'
import Street from './Street/logic.js'
import SubTitle from 'DesignSystem/SubTitle/view.js'
import Zip from './Zip/view.js'
import { css } from "emotion"
AddDependent.displayName = 'AddDependentLogic'
Company.displayName = 'CompanyLogic'
Dependents.displayName = 'DependentsLogic'
EffectiveDate.displayName = 'EffectiveDateLogic'
Email.displayName = 'EmailLogic'
ExistingUsers.displayName = 'ExistingUsersLogic'
FirstName.displayName = 'FirstNameLogic'
Gender.displayName = 'GenderLogic'
LastName.displayName = 'LastNameLogic'
MaritalStatus.displayName = 'MaritalStatusLogic'
Pricing.displayName = 'PricingLogic'
Professionals.displayName = 'ProfessionalsLogic'
ProviderLocations.displayName = 'ProviderLocationsLogic'
State.displayName = 'StateLogic'
Street.displayName = 'StreetLogic'

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
marginTop: 20})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row",
marginTop: 20})
styles.Horizontal2 = css({label: 'Horizontal2',
  flexDirection: "row",
marginTop: 20,
  opacity: 'var(--opacity)'})
styles.Horizontal3 = css({label: 'Horizontal3',
  flexDirection: "row",
marginTop: 20,
  opacity: 'var(--opacity)'})
styles.Horizontal4 = css({label: 'Horizontal4',
  flexDirection: "row",
marginTop: 20})
styles.Horizontal5 = css({label: 'Horizontal5',
  flexDirection: "row",
marginTop: 20})
styles.Horizontal6 = css({label: 'Horizontal6',
  flexDirection: "row",
marginTop: 20})
styles.Horizontal7 = css({label: 'Horizontal7',
  flexDirection: "row",
marginTop: 20})
styles.Horizontal8 = css({label: 'Horizontal8',
  flexDirection: "row",
marginTop: 20})
styles.Horizontal9 = css({label: 'Horizontal9',
  flexDirection: "row",
marginTop: 20})

export default function Add({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  value,
viewPath= "/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
}) {
    
    
    
    
    let data = fromData.useData({ viewPath, path: 'member.useExistingUser', 
context: 'member',
})
    

  return (<React.Fragment
>
<ModalHeader
 data-testid="Add.ModalHeader"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/ModalHeader`}
 text="Add an employee"
>
{childProps => (
<React.Fragment>
<AddAction
{...childProps}
 data-testid="Add.AddAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/AddAction`}
/>
<CancelAction
{...childProps}
 data-testid="Add.CancelAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/CancelAction`}
/>
</React.Fragment>
)}
</ModalHeader>
<ModalContent
 data-testid="Add.ModalContent"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/ModalContent`}
>
{childProps => (
<React.Fragment>
<Info
{...childProps}
 data-testid="Add.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/Info`}
 text="Enrollment has already occurred. The employee will not be allowed to change their plan type or number of enrolled dependents. They will review their personal information, designate PCDs for covered members, and accept terms and conditions."
/>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 marginTop={30}
 text="Select the company"
/>
<div
 data-testid="Add.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
 className={`views-block ${styles.Horizontal}`}
>
<Company
 data-testid="Add.Company"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/Company`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Select an existing user"
/>
<div
 data-testid="Add.Horizontal:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
 className={`views-block ${styles.Horizontal1}`}
>
<ExistingUsers
 data-testid="Add.ExistingUsers"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/ExistingUsers`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 text="Or create new user"
 marginTop={50}
 opacity={data.value ? 0.5 : 1}
/>
<div
 data-testid="Add.Horizontal:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
 style={{'--opacity': data.value ? 0.5 : 1}}
 className={`views-block ${styles.Horizontal2}`}
>
<FirstName
 data-testid="Add.FirstName"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/FirstName`}
/>
<LastName
 data-testid="Add.LastName"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/LastName`}
/>
</div>
<div
 data-testid="Add.Horizontal:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
 style={{'--opacity': data.value ? 0.5 : 1}}
 className={`views-block ${styles.Horizontal3}`}
>
<Email
 data-testid="Add.Email"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/Email`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Personal Details"
/>
<div
 data-testid="Add.Horizontal:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
 className={`views-block ${styles.Horizontal4}`}
>
<DateOfBirth
 data-testid="Add.DateOfBirth"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/DateOfBirth`}
/>
<MaritalStatus
 data-testid="Add.MaritalStatus"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/MaritalStatus`}
/>
<Gender
 data-testid="Add.Gender"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/Gender`}
/>
</div>
<div
 data-testid="Add.Horizontal:5"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
 className={`views-block ${styles.Horizontal5}`}
>
<SocialSecurityNumber
 data-testid="Add.SocialSecurityNumber"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/SocialSecurityNumber`}
/>
<PhoneNumber
 data-testid="Add.PhoneNumber"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/PhoneNumber`}
/>
</div>
<div
 data-testid="Add.Horizontal:6"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
 className={`views-block ${styles.Horizontal6}`}
>
<Street
 data-testid="Add.Street"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/Street`}
/>
</div>
<div
 data-testid="Add.Horizontal:7"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
 className={`views-block ${styles.Horizontal7}`}
>
<City
 data-testid="Add.City"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/City`}
/>
<State
 data-testid="Add.State"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/State`}
/>
<Zip
 data-testid="Add.Zip"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/Zip`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Benefit effective date"
/>
<div
 data-testid="Add.Horizontal:8"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
 className={`views-block ${styles.Horizontal8}`}
>
<EffectiveDate
 data-testid="Add.EffectiveDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/EffectiveDate`}
/>
<PlanStartDate
 data-testid="Add.PlanStartDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/PlanStartDate`}
/>
<ExpiryDate
 data-testid="Add.ExpiryDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/ExpiryDate`}
/>
</div>
<div
 data-testid="Add.Horizontal:9"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
 className={`views-block ${styles.Horizontal9}`}
>
<Plans
 data-testid="Add.Plans"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/Plans`}
/>
<Pricing
 data-testid="Add.Pricing"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/Pricing`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:5"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Primary care location and dentist"
/>
<ProviderLocations
{...childProps}
 data-testid="Add.ProviderLocations"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/ProviderLocations`}
/>
<Professionals
{...childProps}
 data-testid="Add.Professionals"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/Professionals`}
/>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:6"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Dependents"
/>
<Dependents
{...childProps}
 data-testid="Add.Dependents"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/Dependents`}
/>
<AddDependent
{...childProps}
 data-testid="Add.AddDependent"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Add"
viewPath={`${viewPath}/AddDependent`}
/>
</React.Fragment>
)}
</ModalContent>
{children}
</React.Fragment>)
}